import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';
import { createSelector } from 'reselect';

const defaultBrandMessage = <FormattedMessage defaultMessage='Brand' description='filterOptions.brand' id='NsXpxq' />;
const multipleBrandsMessage = (
  <FormattedMessage defaultMessage='(Multiple Brands)' description='filterOptions.multipleBrands' id='deBZJq' />
);

const getDisplayName = ({ appliedFilters, sellerBrands }) => {
  if (appliedFilters.length === 0) {
    return defaultBrandMessage;
  }
  if (appliedFilters.length > 1) {
    return multipleBrandsMessage;
  }
  const [filter] = appliedFilters;
  const matchingBrand = sellerBrands.find((brand) => brand.sellerBrandId === filter.criterionArgumentValue);
  if (!matchingBrand) {
    return defaultBrandMessage;
  }
  return matchingBrand.companyName;
};

const displayNameSelector = createSelector((state) => state, getDisplayName);

const displayContentSelector = createSelector(displayNameSelector, (displayName) => displayName);

const mapStateToProps = (state, ownProps) => {
  const sellerBrands = Global.selectSellerSellerBrands(state);
  const appliedFilters = Global.selectOrdersFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });
  const displayContent = displayContentSelector({
    sellerBrands,
    appliedFilters,
  });

  return {
    isLocked: false,
    isSelected: !!appliedFilters.length,
    displayContent,
  };
};

export const Brand = connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
